module.exports = __webpack_public_path__ + "static/media/uncheckbox_.48229082.svg";